import { DialogContent, Dialog as IFLDialog, DialogProps } from '@indeed/ifl-components'

const Dialog = ({ children, ...props }: DialogProps) => {
  return (
    <IFLDialog {...props}>
      <DialogContent data-syft-locator="Dialog">{children}</DialogContent>
    </IFLDialog>
  )
}

export default Dialog
